import Layout from '@/container/Full'

const Notifications = () => import(/* webpackChunkName: "support" */ '../views/notifications/NotificationsView')

const routes = [
  {
    path: '/notifications',
    component: Layout,
    meta: {
      breadcrumb: 'Notifications',
      pageTitle: 'Notifications',
    },
    children: [
      {
        path: '',
        name: 'notifications',
        component: Notifications,
        meta: {
          breadcrumb: 'Notifications',
          pageTitle: 'Notifications',
          access_type: 'authorized'
        },
      },
    ]
  }
]

export default routes
